import { render, staticRenderFns } from "./SemiologiaOdontologica.vue?vue&type=template&id=2e2fe505"
import script from "./SemiologiaOdontologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaOdontologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports